class FacetCheckbox extends window.BAO.CustomElement({
  SuperClass: HTMLInputElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.addEventListener('change', this.handleChange)
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:facets:updated', () => {
      this.state.facets = this.state.root.facets
      this.disableFacetOption()
    })

    this.eventBus.subscribe('state:activeFacets:updated', () => {
      this.updateCheckedState()
    })

    this.eventBus.subscribe('state:activeFacets:removed', () => {
      this.uncheckFacetOption()
    })
  }

  /**
   * Updates the checked state based on current activeFacets.
   */
  updateCheckedState () {
    this.checked = this.isActive
  }

  disableFacetOption () {
    if (this.count === 0) {
      this.parentElement.setAttribute('aria-disabled', 'true')
      this.disabled = true
    } else {
      this.parentElement.removeAttribute('aria-disabled')
      this.disabled = false
    }
  }

  uncheckFacetOption () {
    const activeFactes = this.state.root.activeFacets

    if (activeFactes.length === 0) {
      this.checked = false
    }

    this.checked = this.isActive
  }

  handleChange (event) {
    const facet = this.dataset.facet
    const option = this.value

    if (event.currentTarget.checked) {
      this.applyFilter(facet, option)
    } else {
      this.removeFilter(facet, option)
    }
  }

  removeFilter (facet, option) {
    this.eventBus.publish('facets-list:remove-filter', {
      facet,
      option,
    })
  }

  applyFilter (facet, option) {
    this.eventBus.publish('facets-list:apply-filter', {
      facet,
      option,
    })
  }

  get count () {
    const key = this.dataset.facet
    const option = this.value

    const facet = this.state.facets.find(facet => facet.key === key)

    if (!facet) return 0

    return facet.options.find(o => o.name === option)?.count || 0
  }

  get isActive () {
    const key = this.dataset.facet
    const value = this.value

    const activeFacets = this.state.root.activeFacets

    const activeFacet = activeFacets.find(facet => facet.key === key)

    if (!activeFacet) return false

    return activeFacet.values.includes(value) || false
  }
}

window.customElements.define('facet-checkbox', FacetCheckbox, {
  extends: 'input',
})
